// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.app-container[data-v-1a474d54] {\n  padding: 20px;\n}\n.credit-limit-banner[data-v-1a474d54] {\n  margin-bottom: 15px;\n  padding: 10px;\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n.credit-detail[data-v-1a474d54] {\n  font-size: 13px;\n  color: #606266;\n}\n", ""]);
// Exports
module.exports = exports;
